import { render, staticRenderFns } from "./ExplicitActivitiesTableSimplified.vue?vue&type=template&id=1b3b1530&scoped=true&"
import script from "./ExplicitActivitiesTableSimplified.vue?vue&type=script&lang=js&"
export * from "./ExplicitActivitiesTableSimplified.vue?vue&type=script&lang=js&"
import style0 from "./ExplicitActivitiesTableSimplified.vue?vue&type=style&index=0&id=1b3b1530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b1530",
  null
  
)

export default component.exports